import src from "IMAGE";
export default { src, width: 45, height: 36, blurWidth: 0, blurHeight: 0};
